var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "box" } },
    [
      _c("iframe", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowCPS,
            expression: "isShowCPS"
          }
        ],
        staticClass: "my_iframe",
        attrs: {
          id: "fram",
          width: "100%",
          height: "100%",
          src: _vm.iframeUrl,
          frameborder: "0"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowCenter,
              expression: "isShowCenter"
            }
          ],
          staticClass: "studenttask_warp"
        },
        [
          _c(
            "el-drawer",
            {
              staticClass: "drawer1",
              attrs: {
                title: "我是标题",
                "modal-append-to-body": false,
                visible: _vm.drawer1,
                "with-header": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.drawer1 = $event
                }
              }
            },
            [
              _vm.drawerState == 4
                ? _c("div", { staticClass: "drawer1_r_box" }, [
                    _c("header", [
                      _c("span", [_vm._v("消息")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: require("../../../../../../static/images/close.png")
                        },
                        on: {
                          click: function($event) {
                            _vm.drawer1 = false
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "drawer1_r_title" }, [
                      _c("p", [_vm._v("发送人:")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.msgObj.toUserName) +
                          " (" +
                          _vm._s(_vm.msgObj.fromStationName) +
                          ")\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.msgObj.type == 0
                      ? _c("div", { staticClass: "drawer1_r_title" }, [
                          _c("p", [_vm._v("内容:")]),
                          _vm._v("任务回退\n          ")
                        ])
                      : _c("div", { staticClass: "drawer1_r_title" }, [
                          _c("p", [_vm._v("内容:")]),
                          _vm._v("无\n          ")
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "drawer1_r_title" }, [
                      _c("p", [_vm._v("留言:")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.msgObj.remark) +
                          "\n          "
                      )
                    ])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "el-drawer",
            {
              staticClass: "drawer2",
              attrs: {
                "modal-append-to-body": false,
                title: "我是标题",
                visible: _vm.drawer2,
                "with-header": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.drawer2 = $event
                }
              }
            },
            [
              _vm.drawerState == 2
                ? _c("div", { staticClass: "r_box" }, [
                    _c("header", [
                      _c("span", [_vm._v("进度查看")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: require("../../../../../../static/images/close.png")
                        },
                        on: {
                          click: function($event) {
                            _vm.drawer2 = false
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "steps_box" },
                      [
                        _c(
                          "el-steps",
                          {
                            attrs: {
                              active: _vm.list2Num,
                              "finish-status": "success",
                              "align-center": ""
                            }
                          },
                          _vm._l(_vm.list2, function(v) {
                            return _c("el-step", {
                              key: v.id,
                              attrs: {
                                title: v.stationName,
                                description: v.name
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "r_ul_box" }, [
                      _c(
                        "ul",
                        { staticClass: "task_r_ul" },
                        [
                          _c("li", { staticClass: "r_li_header" }, [
                            _c("div", { staticClass: "r_li_div_No" }, [
                              _vm._v("序号")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "r_li_div_record" }, [
                              _vm._v("操作记录")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "r_li_div_time" }, [
                              _vm._v("提交时间")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "r_li_div_message" }, [
                              _vm._v("留言")
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.list3, function(item, index) {
                            return _c("li", { key: index }, [
                              _c("div", { staticClass: "r_li_div_No" }, [
                                _vm._v(_vm._s(index + 1))
                              ]),
                              _vm._v(" "),
                              item.toStationName != null
                                ? _c(
                                    "div",
                                    { staticClass: "r_li_div_record" },
                                    [
                                      _vm._v(
                                        _vm._s(item.fromUserName) +
                                          "(" +
                                          _vm._s(item.fromStationName) +
                                          ")给" +
                                          _vm._s(item.toUserName) +
                                          "(" +
                                          _vm._s(item.toStationName) +
                                          ")推送了任务流"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.toStationName == null
                                ? _c(
                                    "div",
                                    { staticClass: "r_li_div_record" },
                                    [
                                      _vm._v(
                                        _vm._s(item.fromUserName) +
                                          "(" +
                                          _vm._s(item.fromStationName) +
                                          ")完结任务"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.createTime
                                ? _c("div", { staticClass: "r_li_div_time" }, [
                                    _vm._v(_vm._s(item.createTime.slice(0, 10)))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !item.createTime
                                ? _c("div", { staticClass: "r_li_div_time" })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "r_li_div_message",
                                  attrs: { title: item.remark }
                                },
                                [_vm._v(_vm._s(item.remark))]
                              )
                            ])
                          })
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.drawerState == 1
                ? _c("div", { staticClass: "r_box2" }, [
                    _c("header", [
                      _c("span", [_vm._v(_vm._s(_vm.obj.taskName))]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: require("../../../../../../static/images/close.png")
                        },
                        on: {
                          click: function($event) {
                            _vm.drawer2 = false
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "r_ct editorShowArea ql-editor",
                      domProps: { innerHTML: _vm._s(_vm.obj.questionContent) },
                      on: {
                        click: function($event) {
                          return _vm.imgCilck($event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "r_footer" }, [
                      _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.jumpCPS(_vm.obj, _vm.obj.id, "ctx")
                            }
                          }
                        },
                        [_vm._v("财天下")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.jumpCPS(_vm.obj, _vm.obj.id, "ptx")
                            }
                          }
                        },
                        [_vm._v("票天下")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.jumpCPS(_vm.obj, _vm.obj.id, "jss")
                            }
                          }
                        },
                        [_vm._v("金税师")]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.drawerState == 3
                ? _c("div", { staticClass: "r_box2" }, [
                    _c("header", [
                      _c("span", [_vm._v(_vm._s(_vm.obj.taskName))]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: require("../../../../../../static/images/close.png")
                        },
                        on: {
                          click: function($event) {
                            _vm.drawer2 = false
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "r_ct editorShowArea ql-editor",
                      domProps: { innerHTML: _vm._s(_vm.obj.questionContent) },
                      on: {
                        click: function($event) {
                          return _vm.imgCilck($event)
                        }
                      }
                    })
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "student_task_t" }, [
            _c("div", { staticClass: "task_t_l" }, [
              _c("button", { staticClass: "btn_null" }, [_vm._v("我的岗位")]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "post_ul" },
                _vm._l(_vm.postList, function(item, index) {
                  return _c("li", { key: index }, [_vm._v(_vm._s(item.name))])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "task_t_r" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.realTaskData.taskName,
                      expression: "realTaskData.taskName"
                    }
                  ],
                  staticClass: "task_t_r_search",
                  attrs: { type: "text", placeholder: "请输入任务名称" },
                  domProps: { value: _vm.realTaskData.taskName },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        $event.keyCode !== 13
                      ) {
                        return null
                      }
                      return _vm.search.apply(null, arguments)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.realTaskData,
                        "taskName",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  { staticClass: "task_t_r_btn", on: { click: _vm.search } },
                  [_vm._v("查询")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "student_task_b" }, [
            _c("div", { staticClass: "student_task_date" }, [
              _c("i", [_vm._v("日期 :")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.dateChange },
                      model: {
                        value: _vm.dateValue,
                        callback: function($$v) {
                          _vm.dateValue = $$v
                        },
                        expression: "dateValue"
                      }
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "全部" } }),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "今天" } }),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "本周" } }),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "本月" } }),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "上月" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _vm.dateButton
                  ? _c(
                      "button",
                      {
                        staticClass: "student_task_b_btn_null",
                        on: { click: _vm.clickDateButton }
                      },
                      [_vm._v("自定义")]
                    )
                  : _c(
                      "div",
                      { staticClass: "picker" },
                      [
                        _c("el-date-picker", {
                          staticClass: "el_calendar1",
                          attrs: {
                            clearable: false,
                            type: "date",
                            placeholder: "开始日期"
                          },
                          on: {
                            change: function($event) {
                              return _vm.getDate1()
                            }
                          },
                          model: {
                            value: _vm.value1,
                            callback: function($$v) {
                              _vm.value1 = $$v
                            },
                            expression: "value1"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "heng" }),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticClass: "el_calendar2",
                          attrs: {
                            clearable: false,
                            type: "date",
                            placeholder: "结束日期"
                          },
                          on: {
                            change: function($event) {
                              return _vm.getDate1()
                            }
                          },
                          model: {
                            value: _vm.value2,
                            callback: function($$v) {
                              _vm.value2 = $$v
                            },
                            expression: "value2"
                          }
                        })
                      ],
                      1
                    )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "student_task_company",
                class: !_vm.companyListState ? "group_true" : ""
              },
              [
                _c("i", [_vm._v("公司 :")]),
                _vm._v(" "),
                !_vm.checkboxState
                  ? _c(
                      "div",
                      { staticClass: "largeArray" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.search },
                            model: {
                              value: _vm.companyValue,
                              callback: function($$v) {
                                _vm.companyValue = $$v
                              },
                              expression: " companyValue"
                            }
                          },
                          [
                            _c("el-radio-button", { attrs: { label: "全部" } }),
                            _vm._v(" "),
                            _vm._l(_vm.companyList, function(item) {
                              return _c(
                                "el-radio-button",
                                { key: item.id, attrs: { label: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkboxState
                  ? _c(
                      "div",
                      { staticClass: "largeArray" },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            attrs: { size: "medium" },
                            on: { change: _vm.search },
                            model: {
                              value: _vm.checkboxGroup2,
                              callback: function($$v) {
                                _vm.checkboxGroup2 = $$v
                              },
                              expression: "checkboxGroup2"
                            }
                          },
                          [
                            _c("el-checkbox-button", {
                              attrs: { disabled: "", label: "全部" }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.companyList, function(item) {
                              return _c(
                                "el-checkbox-button",
                                { key: item.id, attrs: { label: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "student_task_company_r" }, [
                  !_vm.checkboxState
                    ? _c(
                        "button",
                        {
                          staticClass: "btn_white",
                          on: {
                            click: function($event) {
                              return _vm.clickCheck(1)
                            }
                          }
                        },
                        [_vm._v("多选")]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn_white",
                          on: {
                            click: function($event) {
                              return _vm.clickCheck(0)
                            }
                          }
                        },
                        [_vm._v("单选")]
                      ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn_white",
                      staticStyle: { width: "61px" },
                      on: { click: _vm.companyListChange }
                    },
                    [
                      _vm._v("\n              更多\n              "),
                      _vm.companyList.length > 6
                        ? _c("i", { staticClass: "el-icon-arrow-up" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.companyList.length <= 6
                        ? _c("i", { staticClass: "el-icon-arrow-down" })
                        : _vm._e()
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "student_task_type" }, [
              _c("i", [_vm._v("类型 :")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.search },
                      model: {
                        value: _vm.typeValue,
                        callback: function($$v) {
                          _vm.typeValue = $$v
                        },
                        expression: "typeValue"
                      }
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "全部" } }),
                      _vm._v(" "),
                      _vm._l(_vm.taskFlowList, function(item) {
                        return _c(
                          "el-radio-button",
                          { key: item.id, attrs: { label: item.id } },
                          [_vm._v(_vm._s(item.name))]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "student_task_state" },
              [
                _c("i", [_vm._v("状态 :")]),
                _vm._v(" "),
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.search },
                    model: {
                      value: _vm.stateValue,
                      callback: function($$v) {
                        _vm.stateValue = $$v
                      },
                      expression: "stateValue"
                    }
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "全部" } }, [
                      _vm._v("全部")
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: 0 } }, [
                      _vm._v("待办")
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: 4 } }, [
                      _vm._v("等待")
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: 1 } }, [
                      _vm._v("处理中")
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: 2 } }, [
                      _vm._v("已处理")
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: 3 } }, [
                      _vm._v("已完成")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "task_title" }, [
              _vm._v("提示：您有" + _vm._s(_vm.reslTaskNum) + "笔新业务")
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.list.length > 0
              ? _c(
                  "ul",
                  { staticClass: "task_ul" },
                  _vm._l(_vm.list, function(item, index) {
                    return _c("li", { key: index }, [
                      _c("div", { staticClass: "li_div_No" }, [
                        !item.doTaskTime
                          ? _c("i", { staticStyle: { color: "red" } }, [
                              _vm._v("new")
                            ])
                          : _vm._e(),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.pageTotal.currentPage - 1) *
                                _vm.pageTotal.pageSize +
                                index +
                                1
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "li_div_taskName" }, [
                        _vm._v(_vm._s(item.taskName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "li_div_taskCompany" }, [
                        _vm._v(_vm._s(item.companyName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "li_div_time" }, [
                        _vm._v(_vm._s(_vm.post(item.stationId)))
                      ]),
                      _vm._v(" "),
                      item.pushTaskTime
                        ? _c("div", { staticClass: "li_div_time" }, [
                            _vm._v(_vm._s(item.pushTaskTime.slice(0, 10)))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !item.pushTaskTime
                        ? _c("div", { staticClass: "li_div_time" })
                        : _vm._e(),
                      _vm._v(" "),
                      item.teamStatus == 1 && item.userStatus == 0
                        ? _c("div", { staticClass: "li_div_state" }, [
                            _vm._v("等待")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.teamStatus == 1 &&
                      item.userStatus == 1 &&
                      item.doTaskTime == null
                        ? _c("div", { staticClass: "li_div_state" }, [
                            _vm._v("待办")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.teamStatus == 1 &&
                      item.userStatus == 1 &&
                      item.doTaskTime != null
                        ? _c("div", { staticClass: "li_div_state" }, [
                            _vm._v("处理中")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.teamStatus == 1 &&
                      item.userStatus == 2 &&
                      item.doTaskTime != null &&
                      item.submitTime != null
                        ? _c("div", { staticClass: "li_div_state" }, [
                            _vm._v("已处理")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.teamStatus == 2 && item.userStatus == 2
                        ? _c("div", { staticClass: "li_div_state" }, [
                            _vm._v("已完成")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "li_div_schedule" }, [
                        _vm._v(
                          _vm._s(item.finishTaskNum) +
                            "/" +
                            _vm._s(item.allTaskNum)
                        )
                      ]),
                      _vm._v(" "),
                      item.msgId
                        ? _c(
                            "div",
                            {
                              staticClass: "li_div_message",
                              on: {
                                click: function($event) {
                                  return _vm.ckdrawer1(4, item)
                                }
                              }
                            },
                            [_vm._v("新消息")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !item.msgId
                        ? _c("div", { staticClass: "li_div_message" }, [
                            _vm._v(_vm._s(item.msgId))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "li_div_operation" }, [
                        (item.teamStatus == 1 &&
                          item.userStatus == 1 &&
                          item.doTaskTime == null) ||
                        (item.teamStatus == 1 &&
                          item.userStatus == 1 &&
                          item.doTaskTime != null) ||
                        (item.teamStatus == 2 &&
                          item.userStatus == 2 &&
                          item.lastStation)
                          ? _c(
                              "button",
                              {
                                staticClass: "btn_white",
                                on: {
                                  click: function($event) {
                                    return _vm.ckdrawer2(1, item)
                                  }
                                }
                              },
                              [_vm._v("处理")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (item.teamStatus == 1 &&
                          item.userStatus == 2 &&
                          item.doTaskTime != null &&
                          item.submitTime != null) ||
                        (item.teamStatus == 1 && item.userStatus == 0) ||
                        (item.teamStatus == 2 &&
                          item.userStatus == 2 &&
                          !item.lastStation)
                          ? _c(
                              "button",
                              {
                                staticClass: "btn_white",
                                on: {
                                  click: function($event) {
                                    return _vm.ckdrawer2(3, item)
                                  }
                                }
                              },
                              [_vm._v("浏览")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn_white",
                            on: {
                              click: function($event) {
                                return _vm.ckdrawer2(2, item)
                              }
                            }
                          },
                          [_vm._v("进度")]
                        )
                      ])
                    ])
                  }),
                  0
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          !_vm.paginationStatus
            ? _c("div", { staticClass: "null_box" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../static/images/wujieguo.png")
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v("暂无数据")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pageTotal.total > 10
            ? _c("el-pagination", {
                staticClass: "paginator",
                attrs: {
                  "current-page": _vm.pageTotal.currentPage,
                  background: "",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageTotal.pageSize,
                  "pager-count": 5,
                  layout: "sizes, prev, pager, next",
                  total: _vm.pageTotal.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pageTotal, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pageTotal, "currentPage", $event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.dialogVisible && !_vm.isSmall
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              attrs: {
                "close-on-click-modal": false,
                modal: false,
                visible: _vm.dialogVisible,
                width: "50%",
                "show-close": false,
                customClass: "customHeight"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "dia_span" },
                [
                  _c(
                    "span",
                    { staticStyle: { float: "left", "margin-top": "5px" } },
                    [_vm._v("字号：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { float: "left" },
                      on: { change: _vm.fontChange },
                      model: {
                        value: _vm.fontSize,
                        callback: function($$v) {
                          _vm.fontSize = $$v
                        },
                        expression: "fontSize"
                      }
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "默认" } }),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "小号" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        float: "left",
                        "margin-left": "25px",
                        "margin-top": "5px"
                      }
                    },
                    [_vm._v("布局：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { float: "left" },
                      on: { change: _vm.layoutChange },
                      model: {
                        value: _vm.diaLayout,
                        callback: function($$v) {
                          _vm.diaLayout = $$v
                        },
                        expression: "diaLayout"
                      }
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "浮窗" } }),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "左右" } }),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "上下" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isMini
                    ? _c("i", {
                        staticClass: "small_icon el-icon-minus",
                        on: { click: _vm.small }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isHalf
                    ? _c("i", {
                        staticClass: "large_icon el-icon-copy-document",
                        on: { click: _vm.largeHalf }
                      })
                    : _c("i", {
                        staticClass: "large_icon el-icon-full-screen",
                        on: { click: _vm.large }
                      }),
                  _vm._v(" "),
                  _c("i", {
                    directives: [
                      {
                        name: "bury",
                        rawName: "v-bury",
                        value: { route: _vm.$route, template: _vm.template },
                        expression: "{route: $route,template:template}"
                      }
                    ],
                    staticClass: "el-icon-back",
                    staticStyle: { "margin-right": "15px" },
                    on: { click: _vm.back }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tabs",
                {
                  staticStyle: { padding: "0 20px" },
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: " 题 面 ", name: "first" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "aside",
                          class: { font_size: _vm.changeFont }
                        },
                        [
                          _c("div", {
                            staticClass: "qesCont editorShowArea ql-editor",
                            domProps: {
                              innerHTML: _vm._s(_vm.obj.questionContent)
                            },
                            on: {
                              click: function($event) {
                                return _vm.imgCilck($event)
                              }
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { staticClass: "task_submit", on: { click: _vm.taskSubmit } },
                [_vm._v("任务提交")]
              ),
              _vm._v(" "),
              _vm.backState
                ? _c(
                    "el-button",
                    {
                      staticClass: "task_submit2",
                      on: { click: _vm.taskfallback }
                    },
                    [_vm._v("退回")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  staticClass: "count_down_dialog",
                  attrs: {
                    width: "30%",
                    title: "提示",
                    "show-close": false,
                    visible: _vm.innerVisible,
                    "close-on-click-modal": false,
                    "append-to-body": ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.innerVisible = $event
                    }
                  }
                },
                [
                  _c("div", { staticClass: "count_down_main" }, [
                    _c("p", [_vm._v("您的操作已经提交")]),
                    _vm._v(" "),
                    _c("p", [
                      _c("span", [_vm._v(_vm._s(_vm.countDown) + "秒")]),
                      _vm._v("后将自动返回待办任务列表页\n          ")
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  staticClass: "count_down_dialog2",
                  attrs: {
                    width: "30%",
                    title: "退回",
                    "show-close": false,
                    visible: _vm.innerVisible2,
                    "close-on-click-modal": false,
                    "append-to-body": ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.innerVisible2 = $event
                    }
                  }
                },
                [
                  _c("div", { staticClass: "count_down_main" }, [
                    _c("div", { staticClass: "count_down_dialog_r_title" }, [
                      _c("p", [_vm._v("任务退回给:")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.backObj.name) +
                          " (" +
                          _vm._s(this.backObj.stationName) +
                          ")\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "count_down_dialog_r_ct" }, [
                      _c("p", [_vm._v("留言:")]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.notedata,
                            expression: "notedata"
                          }
                        ],
                        attrs: {
                          placeholder: "请输入退回理由",
                          maxlength: "200",
                          cols: "25",
                          rows: "5"
                        },
                        domProps: { value: _vm.notedata },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.notedata = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.notedata.length) + "(上限200)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "count_down_dialog_r_footer" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "cancel",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.fallback(0)
                              }
                            }
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.fallback(1)
                              }
                            }
                          },
                          [_vm._v("确定")]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSmall ? _c("drag-icon") : _vm._e(),
      _vm._v(" "),
      _vm.showBigImg
        ? _c("div", { staticClass: "bigImg" }, [
            _c("div", { staticClass: "mask" }),
            _vm._v(" "),
            _c("div", { staticClass: "imgBox" }, [
              _c("img", {
                attrs: { src: _vm.imgUrl, alt: "" },
                on: { click: _vm.clickMask }
              })
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "task_ul_header" }, [
      _c("li", { staticClass: "li_header" }, [
        _c("div", { staticClass: "li_div_No" }, [_vm._v("序号")]),
        _vm._v(" "),
        _c("div", { staticClass: "li_div_taskName" }, [_vm._v("任务名称")]),
        _vm._v(" "),
        _c("div", { staticClass: "li_div_taskCompany" }, [_vm._v("所属公司")]),
        _vm._v(" "),
        _c("div", { staticClass: "li_div_time" }, [_vm._v("岗位")]),
        _vm._v(" "),
        _c("div", { staticClass: "li_div_time" }, [_vm._v("任务发布时间")]),
        _vm._v(" "),
        _c("div", { staticClass: "li_div_state" }, [_vm._v("状态")]),
        _vm._v(" "),
        _c("div", { staticClass: "li_div_schedule" }, [_vm._v("任务进度")]),
        _vm._v(" "),
        _c("div", { staticClass: "li_div_message" }, [_vm._v("留言")]),
        _vm._v(" "),
        _c("div", { staticClass: "li_div_operation" }, [_vm._v("操作")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b9ee67d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b9ee67d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/realTask/studentTask.vue
// module id = null
// module chunks = 